"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeUrl = normalizeUrl;
/**
 * Normalizes a URL by lowercasing it, adding the trailing slash,
 * and removing the default ports (:80 for http and :443 for https).
 * @param url URL to normalize.
 * @example
 *   normalizeUrl('HTTP://EXAMPLE.COM') === 'http://example.com/'
 *   normalizeUrl('http://example.com:80') === 'http://example.com/'
 *   normalizeUrl('https://example.com:443') === 'https://example.com/'
 */
function normalizeUrl(url) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
//# sourceMappingURL=normalizeUrl.js.map